import { type ActionItem } from 'shared/ui'
import { type TableStore } from 'shared/ui/TableNew/store/tableStore'
import { type RowUser } from 'entities/Users/model/Table/RowUser'
import { logoutAllDevices } from 'pages/settings/pages/members/ui/actions/logoutAllDevices/logoutAllDevices'

type BulkActionParams = {
  tableStore: TableStore<RowUser>
  search: string
}

export const getMembersBulkActions = (users: RowUser[], params: BulkActionParams): ActionItem[] => {
  const { tableStore, search } = params

  const onBulkActionSuccess = () => {
    tableStore.resetSelected()
  }

  return [
    logoutAllDevices(users, onBulkActionSuccess, {
      all: tableStore.bulkAllMode,
      search,
      total: tableStore.bulkTotal,
    }),
  ]
}
